import { OptionService } from './option.service';

export const OptionInjectables: Array<any> = [
  {
    provide: OptionService,
    useClass: OptionService,
  },
];
